/**
 * @generated SignedSource<<0dc32429062aedae463d760379c15299>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateRoomPropertyInput = {
  etgKey?: string | null;
  name?: string | null;
};
export type RoomPropertyEditFormMutation$variables = {
  id: string;
  input: UpdateRoomPropertyInput;
};
export type RoomPropertyEditFormMutation$data = {
  readonly updateRoomProperty: {
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "RoomPropertyEditForm_roomProperty">;
  };
};
export type RoomPropertyEditFormMutation = {
  response: RoomPropertyEditFormMutation$data;
  variables: RoomPropertyEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoomPropertyEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoomProperty",
        "kind": "LinkedField",
        "name": "updateRoomProperty",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoomPropertyEditForm_roomProperty"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoomPropertyEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoomProperty",
        "kind": "LinkedField",
        "name": "updateRoomProperty",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "etgKey",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "450c4c8d3d9fa469eae6d8f52cf4df36",
    "id": null,
    "metadata": {},
    "name": "RoomPropertyEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation RoomPropertyEditFormMutation(\n  $id: ID!\n  $input: UpdateRoomPropertyInput!\n) {\n  updateRoomProperty(id: $id, input: $input) {\n    ...EntitySidebar_entity\n    ...RoomPropertyEditForm_roomProperty\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment RoomPropertyEditForm_roomProperty on RoomProperty {\n  id\n  name\n  etgKey\n}\n"
  }
};
})();

(node as any).hash = "6c432e843740210b8207a05adb5c8fa7";

export default node;
